import { signout } from '../../api/Auth/logout.api';
import { LOGOUT, LOGOUT_FAIL } from './types';

export const proceedLogOut = () => {
	return async (dispatch) => {
		try {
			console.log('proceedLogOut');
			signout();
			dispatch(logoutSuccessful);
		} catch {
			dispatch(logoutFail);
		}
	};
};

const logoutSuccessful = (payload) => ({
	type: LOGOUT,
	payload,
});

const logoutFail = () => ({
	type: LOGOUT_FAIL,
});
